import Head from './layout/Head';
import Content from './layout/Content';
import './App.css';

function App() {
  return (
    <div className="App">
      <Head />
      <Content />
    </div>
  );
}

export default App;
